export const UPDATED = "July 2026";

export const OPTIONS = [
  { id: "carfornia", name: "Carfornia Buyers", sub: "Local veteran-owned buyer (Hayward)", highlight: true },
  { id: "carmax", name: "CarMax", sub: "National used-car retailer" },
  { id: "carvana", name: "Carvana", sub: "Online retailer" },
  { id: "tradein", name: "Dealer trade-in", sub: "When buying your next car" },
  { id: "private", name: "Private sale", sub: "Craigslist, Facebook, Autotrader" },
];

// Competitor rows describe their generally published processes as of UPDATED. Always hedge; never invent numbers.
export const ROWS = [
  { label: "How you get a number", cells: {
    carfornia: "Request online; we review it personally and call or text you back. The real, written offer comes after we see the car.",
    carmax: "Online instant offer or in-store appraisal.",
    carvana: "Online offer in minutes from the VIN or plate plus your answers.",
    tradein: "Appraisal at the dealership, usually bundled into the new-car negotiation.",
    private: "You set the price; buyers negotiate it down.",
  } },
  { label: "Where the inspection happens", cells: {
    carfornia: "At your home or office across the Bay Area — we come to you at no charge.",
    carmax: "At a CarMax store.",
    carvana: "At pickup; the offer can change if the car differs from what you entered.",
    tradein: "At the dealership while you shop.",
    private: "Wherever you meet strangers for test drives.",
  } },
  { label: "Who is actually buying", cells: {
    carfornia: "We are. We resell cars ourselves, so we are not pricing in auction fees and transport.",
    carmax: "CarMax; cars that do not fit retail are typically wholesaled.",
    carvana: "Carvana; cars outside their retail profile are typically wholesaled.",
    tradein: "The dealer; many trade-ins go straight to auction.",
    private: "An individual buyer.",
  } },
  { label: "Older, high-mileage, salvage or lien cars", cells: {
    carfornia: "Yes — all are reviewed. Condition and title affect the offer, but we will tell you up front.",
    carmax: "Generally yes, often at wholesale-level pricing.",
    carvana: "Limits apply; some titles and conditions are declined.",
    tradein: "Usually accepted but valued at wholesale.",
    private: "Possible, but a smaller pool of buyers.",
  } },
  { label: "Payment", cells: {
    carfornia: "Same day you accept, by the method agreed in writing. We do not take the car until payment is arranged.",
    carmax: "Typically a bank draft at the store.",
    carvana: "Typically at pickup by ACH or check.",
    tradein: "Credited toward the new car.",
    private: "Cash, cashier's check or app — you carry the fraud risk.",
  } },
  { label: "Paperwork", cells: {
    carfornia: "We complete the title transfer, odometer disclosure and DMV Release of Liability with you.",
    carmax: "Handled at the store.",
    carvana: "Handled at pickup / online.",
    tradein: "Handled by the dealership.",
    private: "You handle title, smog certificate (usually the seller's job in California), bill of sale and DMV forms.",
  } },
  { label: "Best for", cells: {
    carfornia: "Bay Area and Oahu owners who want a real local buyer, a fair written offer, and to be paid the same day without driving anywhere.",
    carmax: "Sellers who want a nationwide brand and are near a store.",
    carvana: "Sellers who want a fully online process and have a clean, mainstream car.",
    tradein: "Convenience when you are already buying from that dealer.",
    private: "Sellers with time and patience chasing the highest possible price.",
  } },
  { label: "Honest downside", cells: {
    carfornia: "We are one local buyer, not a nationwide chain, and our offer comes after an inspection — not instantly on screen. We serve the Bay Area, nearby Northern California and Oahu only.",
    carmax: "You bring the car to them, and the offer can be conservative on older or unusual vehicles.",
    carvana: "Offer can be adjusted at pickup; stricter on condition and title.",
    tradein: "Typically the lowest number, and California does not give a sales-tax credit for a trade-in.",
    private: "Scams, no-shows, test drives with strangers, and you remain liable until the DMV transfer is filed.",
  } },
];

export const COMPARE_FAQS = [
  { q: "Who pays the most for a used car in the Bay Area?",
    a: "It depends on the car. A patient private seller with a clean, in-demand vehicle can sometimes get the highest price. Among buyers who take the hassle off your hands, local buyers who resell cars themselves — like Carfornia Buyers — are often able to pay more than national chains or a dealer trade-in, because they are not pricing in auction fees and transport. The honest way to find out is to get a CarMax or Carvana number, then upload it to us and let us try to beat it." },
  { q: "Is Carvana or CarMax better for selling a car?",
    a: "Carvana is more convenient (fully online, they pick the car up) but can adjust the offer at pickup and is stricter about condition and title. CarMax requires a store visit but you leave with a firm number after their appraisal. Both tend to be conservative on older, high-mileage or non-mainstream vehicles. Neither is a bad option — just compare them against a local buyer before you decide." },
  { q: "Should I trade in my car or sell it separately?",
    a: "In California, selling separately usually comes out ahead. Unlike many states, California does not reduce the sales tax on your new car by the value of your trade-in, so the main advantage of trading in is convenience. If a local buyer or online retailer offers you more than the dealer, you can sell to them and bring the proceeds to the dealership." },
  { q: "Do I need a smog certificate to sell my car to Carfornia Buyers?",
    a: "In a private-party sale the seller is usually responsible for providing a smog certificate. When you sell to us we go over smog, title and registration with you at the inspection and tell you exactly what, if anything, you need to do — most sellers do not need to handle anything on their own. Check the California DMV site for the current rules for your specific vehicle." },
  { q: "How do I compare offers fairly?",
    a: "Compare the number you would actually walk away with, not the headline. Ask: Is the offer firm or can it change at pickup? Do I have to drive somewhere? How and when am I paid? Is a loan payoff included? Carfornia Buyers gives you a written offer after inspection, at your location, with same-day payment — so what you see is what you get." },
];
